const SET_GLOBAL_ORGANIZATION = 'SET_GLOBAL_ORGANIZATION';
const GET_BRANCHES = 'GET_BRANCHES';
const GET_ORGANIZATION_ROLES = 'GET_ORGANIZATION_ROLES';
const GET_MASTER_ORGANIZATIONS = 'GET_MASTER_ORGANIZATIONS';
const CLEAR = 'CLEAR';
const GET_ALL_ORGANIZATION_ROLES = 'GET_ALL_ORGANIZATION_ROLES';
const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
const GET_ORGANIZATIONS_BY_NAME = 'GET_ORGANIZATIONS_BY_NAME';
const GET_ORGANIZATION_BY_GUID = 'GET_ORGANIZATION_BY_GUID';
const GET_ORGANIZATIONS_BY_TYPE = 'GET_ORGANIZATIONS_BY_TYPE';
const GET_ORGANIZATIONS_BY_TYPE_PARENT = 'GET_ORGANIZATIONS_BY_TYPE_PARENT';

export default {
	SET_GLOBAL_ORGANIZATION,
	GET_BRANCHES,
	GET_ORGANIZATION_ROLES,
	GET_MASTER_ORGANIZATIONS,
	CLEAR,
	GET_ALL_ORGANIZATION_ROLES,
	SET_ORGANIZATIONS,
	GET_ORGANIZATIONS_BY_NAME,
	GET_ORGANIZATION_BY_GUID,
	GET_ORGANIZATIONS_BY_TYPE,
	GET_ORGANIZATIONS_BY_TYPE_PARENT,
};
